import { useSegments } from "expo-router"
import { getScreenName } from "@/constants/Screens"

export const useScreenName = () => {
  const segments = useSegments()
  const screenKey = segments.join("-") || "index"

  return getScreenName(screenKey)
}
